import request from '@f/utils/request'

let base_url = 'v1'

export function apiGet(data) {
    return request({
        url: base_url + '/form-survey/get-information?' + data,
        method: 'get',
    })
}